import { IFormInputOption } from "@components/form/interfaces/form-interface"

export const digitalMarketingOptions: IFormInputOption[] = [
  { label: 'Começando agora', value: 'Começando agora' },
  { label: 'Me viro bem', value: 'Me viro bem' },
  { label: 'Entusiasta', value: 'Entusiasta' },
  { label: 'Profissional', value: 'Profissional' }
]

export const mainObjectiveOptions: IFormInputOption[] = [
  { label: 'Ampliar o alcance da minha marca', value: 'Ampliar o alcance da minha marca' },
  { label: 'Garantir posts com regularidade', value: 'Garantir posts com regularidade' },
  { label: 'Construir uma imagem de autoridade', value: 'Construir uma imagem de autoridade' },
  { label: 'Manter consistência de voz e estilo em posts', value: 'Manter consistência de voz e estilo em posts' },
  { label: 'Analisar o engajamento de seguidores', value: 'Analisar o engajamento de seguidores' },
  { label: 'Capturar interesse em meus produtos/serviços', value: 'Capturar interesse em meus produtos/serviços' },
  { label: 'Divulgar promoções e eventos pontuais', value: 'Divulgar promoções e eventos pontuais' },
  { label: 'Gerar tráfego para o meu site ou página', value: 'Gerar tráfego para o meu site ou página' },
  { label: 'Entender melhor meu público alvo', value: 'Entender melhor meu público alvo' },
  { label: 'Outro', value: 'Outro' }
]

export const hearAboutCopymagicoOptions: IFormInputOption[] = [
  { label: 'Artigo em um Blog', value: 'Artigo em um Blog' },
  { label: 'Evento (Online ou Presencial)', value: 'Evento (Online ou Presencial)' },
  { label: 'Indicação de amigo', value: 'Indicação de amigo' },
  { label: 'Newsletter que assino', value: 'Newsletter que assino' },
  { label: 'Notícia ou site sobre IA', value: 'Notícia ou site sobre IA' },
  { label: 'Pesquisa no Google (ou outro buscador)', value: 'Pesquisa no Google (ou outro buscador)' },
  { label: 'Podcast', value: 'Podcast' },
  { label: 'Sigo vocês no Facebook', value: 'Sigo vocês no Facebook' },
  { label: 'Sigo vocês no Instagram', value: 'Sigo vocês no Instagram' },
  { label: 'Sigo vocês no LinkedIn', value: 'Sigo vocês no LinkedIn' },
  { label: 'Vi no Facebook (anúncio ou indicação)', value: 'Vi no Facebook (anúncio ou indicação)' },
  { label: 'Vi no Instagram (anúncio ou indicação)', value: 'Vi no Instagram (anúncio ou indicação)' },
  { label: 'Vi no LinkedIn (anúncio ou indicação)', value: 'Vi no LinkedIn (anúncio ou indicação)' },
  { label: 'Vi no TikTok (anúncio ou indicação)', value: 'Vi no TikTok (anúncio ou indicação)' },
  { label: 'Vi no Youtube (anúncio ou indicação)', value: 'Vi no Youtube (anúncio ou indicação)' }
]
